import { render, staticRenderFns } from "./LeftSide.vue?vue&type=template&id=6e2c293d&scoped=true"
import script from "./LeftSide.vue?vue&type=script&lang=js"
export * from "./LeftSide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2c293d",
  null
  
)

export default component.exports